import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { UIRouterModule } from "@uirouter/angular";
import { ComponentModule } from "../components/components.module";
import { ModalModule } from "../modals/modal.module";
import { PipesModule } from "../pipes/pipes.module";
import { ServiceModule } from "../services/service.module";
import { ComplianceItemActionButtonComponent } from "./components/compliance-item-action-button/compliance-item-action-button.component";
import { ComplianceReminderFilterPipe } from "./pipes/compliance-reminder-filter.pipe";
import { MonthDayDisplayPipe } from "./pipes/month-day-display/month-day-display.pipe";
import { MonthDisplayPipe } from "./pipes/month-display.pipe";
import { RecurrenceSummaryPipe } from "./pipes/recurrence-summary.pipe";
import { WeekdayDisplayPipe } from "./pipes/weekday-display.pipe";
import { WeekdayIntervalDisplayPipe } from "./pipes/weekday-interval-display.pipe";
import { StatusIndicatorComponent } from "./components/status-indicator/status-indicator.component";
import { ComplianceItemsListComponent } from "./components/compliance-items-list/compliance-items-list.component";
import { ComplianceItemSummaryComponent } from "./components/compliance-item-summary/compliance-item-summary.component";
import { EdlCommonComponentsModule, EdlCommonDirectiveModule, EdlCommonPipesModule } from "@edl-development/edl-common";
import { ComplyDirectivesModule } from "../directives/comply-directives.module";

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(),
        EdlCommonDirectiveModule,
        ComplyDirectivesModule,
        ModalModule,
        EdlCommonPipesModule,
        PipesModule,
        NgbModule,
        ReactiveFormsModule,
        FormsModule,
        ServiceModule,
        ComponentModule,
        EdlCommonComponentsModule
    ],
    declarations: [
        ComplianceItemActionButtonComponent,
        ComplianceItemSummaryComponent,
        ComplianceItemsListComponent,
        StatusIndicatorComponent,
        ComplianceReminderFilterPipe,
        RecurrenceSummaryPipe,
        MonthDisplayPipe,
        WeekdayIntervalDisplayPipe,
        MonthDayDisplayPipe,
        WeekdayDisplayPipe
    ],
    exports: [
        ComplianceItemActionButtonComponent,
        ComplianceItemsListComponent,
        ComplianceItemSummaryComponent,
        StatusIndicatorComponent,
        ComplianceReminderFilterPipe,
        RecurrenceSummaryPipe,
        MonthDisplayPipe,
        WeekdayIntervalDisplayPipe,
        MonthDayDisplayPipe,
        WeekdayDisplayPipe
    ]
})
export class SharedComplianceItemsModule { }
